export const DT_STACK_DIRECTION = {
  default: 'column',
  column: 'column',
  row: 'row',
  'row-reverse': 'row-reverse',
  'column-reverse': 'column-reverse',
};

export const DT_STACK_RESPONSIVE_BREAKPOINTS = ['sm', 'md', 'lg', 'xl'];

export const DT_STACK_GAP = ['0', '50', '100', '200', '300', '350', '400', '450', '500', '525', '550', '600', '625', '650', '700'];

export default {
  DT_STACK_DIRECTION,
  DT_STACK_RESPONSIVE_BREAKPOINTS,
  DT_STACK_GAP,
};
